import React, { useState, useEffect } from 'react';
import propTypes from 'prop-types';
import { FingerprintContext } from './FingerprintContext';
import withApolloClient from '../../hocs/withApolloClient';
import generateFingerprint from '../../helpers/generateFingerprint';

const FingerprintProvider = ({ children }) => {
  const [fingerprint, setFingerprint] = useState(null);

  useEffect(() => {
    if (localStorage.getItem('bnnvara-fingerprint')) {
      return setFingerprint(localStorage.getItem('bnnvara-fingerprint'));
    }

    const getFingerprint = async () => {
      const fingerprintId = await generateFingerprint();

      // store fingerprint in localstorage
      localStorage.setItem('bnnvara-fingerprint', fingerprintId);
      setFingerprint(fingerprintId);
    };

    return getFingerprint();
  }, [fingerprint]);

  return (
    <FingerprintContext.Provider value={fingerprint}>
      {children}
    </FingerprintContext.Provider>
  );
};

FingerprintProvider.propTypes = {
  children: propTypes.node,
};

export default withApolloClient(FingerprintProvider);
